module.exports = __webpack_public_path__ + "media/images/textbaba_logo-cf1f1ca154efbae0334a48964269ef97.jpeg";